import { Filter, FilterableItem, FilteredByOtherFilters } from "./useFilter";

export type Filteredtems<T extends FilterableItem> = {
  byAll: T[];
  byOtherFilters: FilteredByOtherFilters<T>;
};

const dropElement = <T>(array: T[], index: number): T[] => [...array.slice(0, index), ...array.slice(index + 1)];

const filterByAllExceptOne = <T extends FilterableItem>(items: T[], filters: Filter<T>[], skippedIndex: number) =>
  items.filter((item) => dropElement(filters, skippedIndex).every(({ filterPredicate }) => filterPredicate(item)));

const getFilteredItems = <T extends FilterableItem>(filters: Filter<T>[], items: T[] = []): Filteredtems<T> =>
  filters.reduce(
    (acc, { filterPredicate, key: filterLabel }, index) => ({
      byAll: acc.byAll.filter(filterPredicate),
      byOtherFilters: {
        ...acc.byOtherFilters,
        [filterLabel]: filterByAllExceptOne(items, filters, index),
      },
    }),
    { byAll: items, byOtherFilters: {} }
  );

export default getFilteredItems;
